<template>
 <el-dialog
      :title="id ? '编辑' : '添加'"
      :visible.sync="isVisiable"
      width="40%"
      @close="doCancel"
    >
      <el-form
        :model="dateForm"
        label-width="120px"
        class="add-role-form"
        :rules="dataRule"
        ref="formName"
      >
        <el-form-item label="分组标题：" prop="title">
          <el-input
              v-model="dateForm.title"
              :disabled="id"
              size="small"
              placeholder="请输入分组标题"
          ></el-input>
        </el-form-item>

        <el-form-item label="消息标题：" prop="messageTitle">
          <el-input
              v-model="dateForm.messageTitle"
              size="small"
              placeholder="请输入消息标题"
          ></el-input>
        </el-form-item>

        <el-form-item label="模板内容：" prop="content">
            <el-input
                v-model="dateForm.content"
                type="textarea"
                placeholder="请输入模板内容"
                :autosize="{ minRows: 4}"
            ></el-input>
        </el-form-item>

        <el-form-item label="备注：">
            <el-input
                v-model="dateForm.remark"
                type="textarea"
                placeholder="请输入备注"
                :maxlength="500"
                :autosize="{ minRows: 4}"
            ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="doCancel">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="doConfirm">保 存</el-button>
      </span>
    </el-dialog>
</template>
<script>
const dateForm = {
    id: '',
    title: "",
    messageTitle: "",
    content: "",
    remark: '',
}
export default {
  name: "EditTemp",
  props: {
      isVisiable: {
          type: Boolean,
          default: false
      },
      id: {
          type: [String , Number] ,
          default: ''
      }
  },
  data () {
    return {
        dateForm: this._.cloneDeep(dateForm),
        dataRule: {
          title: [
                { required: true, message: "请输入至少1个字符，最多100个字符！", trigger: "blur" },
            ],
          messageTitle: [
            { required: true, message: "请输入至少1个字符，最多100个字符！", trigger: "blur" },
          ],
          content: [
                { required: true, message: "必须输入模板内容,请输入日文！", trigger: "blur" },
            ],
        },
    };
  },
  watch: {
      id(val) {
          if(val) {
              this.dateForm.id = val
              this.getDetail()
          } else {
              this.dateForm = this._.cloneDeep(dateForm)
          }
      },
      isVisiable(val){
          if (val && this.dateForm.id != ''){
            this.getDetail()
          }
      }
  },
    methods: {
        getDetail () {
            this.$http.get(`/orderGroup/${this.id}`, {}).then(res => {
                let info = res.data.data
                Object.keys(this.dateForm).forEach(key => {
                    this.dateForm[key] = info[key]
                })
            })
        },
        doConfirm() {
            const self = this;
            this.$refs.formName.validate(async function (valid) {
                if (valid) {
                    const { data: res } = await self.$http.post(
                        "/orderGroup/save",
                        self.dateForm
                    );
                    self.dateForm.id = '';
                    self.dateForm.title = '';
                    self.dateForm.content = '';
                    self.dateForm.remark = '';

                    if (res.code == 200) {
                        self.$message({
                            type: "success",
                            message: res.message,
                        });
                        self.$emit('confirm')
                    } else {
                        self.$message.error(res.message);
                    }
                }
            });
        },
        doCancel() {
            this.$emit('update:isVisiable', false)
        }
    }
}
</script>
<style lang="scss" scoped>
</style>
